import React from 'react';
import { Item } from '../item';
import utils from '../../../utils';
import './highlightedpanel.scss';

export function HighlightedPanel(props) {
    const item = props.item;
    const subItems = item.items || [];
    const cmsOption = props.cmsOption || {};

    const cssClass = utils.classNames('cms_item', 'highlightedPanel', item.cssClass || item.anchorName || '');

    const subItemsElts = subItems.map((subItem, index) =>
        <Item item={subItem} key={subItem.itemId} cmsOption={cmsOption}></Item>
    );

    return (
        <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}>
            {subItemsElts}
        </div>
    );

}